import React, { useEffect } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import AddProduct from './product/AddProduct';
import AddInspiration from './inspiration/AddInspiration';

const AddData = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabValue = searchParams.get('tab') || '1';
    const [value, setValue] = React.useState(tabValue);

    useEffect(() => {
        setValue(tabValue);
    }, [tabValue]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setSearchParams({ tab: newValue });
    };

    return (
        <div className='content'>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                        <Tab label="Product" value="1" />
                        <Tab label="Inspiration" value="2" />
                        <Tab label="Docs" value="3" />
                    </TabList>
                </Box>
                <TabPanel value="1">
                    <AddProduct />
                </TabPanel>
                <TabPanel value="2">
                    <AddInspiration />
                </TabPanel>
                <TabPanel value="3">Item Three</TabPanel>
            </TabContext>
        </div>
    );
};

export default AddData;